const MAX = 40;
const BASE = "Tee On";

export function buildAdminTabTitle(primarySegment: string | undefined | null): string {
  const raw = primarySegment?.trim();
  if (!raw) {
    return BASE;
  }
  const name = raw.length > MAX ? `${raw.slice(0, MAX - 1)}…` : raw;
  return `${name} - ${BASE}`;
}
